import { useDisclosure } from "./LDJKN2ZV.js";
import { createComponent, createElement, createHook } from "./NQJBHION.js";
import { __objRest, __spreadValues } from "./PNRLI7OV.js";

// src/dialog/dialog-disclosure.ts
var useDialogDisclosure = createHook(_a => {
  var _b = _a,
    {
      store
    } = _b,
    props = __objRest(_b, ["store"]);
  props = useDisclosure(__spreadValues({
    store
  }, props));
  return props;
});
var DialogDisclosure = createComponent(props => {
  const htmlProps = useDialogDisclosure(props);
  return createElement("button", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  DialogDisclosure.displayName = "DialogDisclosure";
}
export { useDialogDisclosure, DialogDisclosure };